// src/pwa/usePwaInstallMenu.ts
import { useEffect, useState, useCallback } from "react";
import { subscribeInstallAvailability, promptPwaInstall } from "./installPrompt";

export function usePwaInstallMenu() {
  const [isInstallAvailable, setIsInstallAvailable] = useState(false);

  useEffect(() => {
    return subscribeInstallAvailability(setIsInstallAvailable);
  }, []);

  const runInstall = useCallback(async () => {
    return await promptPwaInstall();
  }, []);

  return { isInstallAvailable, runInstall };
}
